<template>
    <!--弹窗-->
    <el-dialog width="500px" :title="title" :visible.sync="visible" :before-close="handleClose">
        <el-form ref="formData" :model="formData" label-width="100px">
        <el-form-item label="备注：">
            <el-input
                style="width: 300px;"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 6}"
                placeholder="请输入备注。"
                v-model="formData.manager_remark"
            ></el-input>
        </el-form-item>
        </el-form>
        <el-row style="margin-top:17px; ">
        <el-button
            style="float:right;margin-left:6px;"
            size="mini"
            type="danger"
            plain
            @click="handleClose(true)"
        >取 消</el-button>
        <el-button style="float:right" size="mini" type="primary" @click="submitForm('formData')" :loading="loading">确定</el-button>
        </el-row>
    </el-dialog>
</template>
<script>
import * as api from "@/api/user/user";
export default {
    data() {
        return {
            loading: false
        };
    },
    props: {
        formData: {
            type: Object,
            default: () => {}
        },
        visible: {
            type: Boolean,
            default: false
        },
        credit: {
            type: String,
            default: ""
        },
        title: {
            type: String,
            default: ""
        }
    },
    methods: {
        // 保存信息
        submitForm(formData) {
            this.$refs[formData].validate(valid => {
                if (valid) {
                    this.loading = true;
                    let obj = {};
                    obj.user_id = this.formData.id;
                    obj.remark = this.formData.manager_remark;
                    api.remark(obj)
                        .then(res => {
                            if (res.code === 0) {
                                // 提交成功, 关闭窗口, 刷新列表
                                this.$message({
                                    message: "备注成功",
                                    type: "success"
                                });
                                this.handleClose(false);
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.message
                                });
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message({
                                type: "error",
                                message:
                                    "网络出现错误，请刷新页面后，再次尝试！"
                            });
                        });
                } else {
                    this.$message({
                        type: "error",
                        message: "请填写相应内容！"
                    });
                }
            });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.$refs["formData"].resetFields();
            this.loading = false;
            this.$emit("close-callback", isshow);
        }
    }
};
</script>
